var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-model',{attrs:{"type":"ADMIN_REQUEST","view-action":_vm.viewAction,"delete-action":_vm.deleteAction,"add-action":_vm.addAction,"update-action":_vm.updateAction,"intranet":_vm.intranet}})}
var staticRenderFns = []

export { render, staticRenderFns }